import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    AuthScreen,
    AuthBody,
    AuthFooter,
    ScreenHeader,
    TextField,
    PrimaryButton,
} from "@/screens/auth/_ui";
import { useAuth } from "@/context/AuthContext";
import { setOTP } from "@/lib/storage";
import { sendOtp } from "@/lib/termii";

const ForgotIdentifier = () => {
    const navigate = useNavigate();
    const { identifierIsTaken } = useAuth();
    const [value, setValue] = useState("");
    const [error, setError] = useState(null);

    const handleContinue = async () => {
        const v = value.trim();
        if (!v) {
            setError("Enter your email or phone");
            return;
        }
        if (!identifierIsTaken(v)) {
            setError("Account not found");
            return;
        }
        const channel = /[a-zA-Z]/.test(v) ? "email" : "sms";
        const result = await sendOtp({ identifier: v, purpose: "forgot", channel });
        if (!result.ok) {
            setError(result.error || "Could not send code. Please try again.");
            return;
        }
        setOTP({
            purpose: "forgot",
            identifier: v,
            pinId: result.pinId || null,
            sentAt: Date.now(),
        });
        navigate("/auth/forgot/otp");
    };

    return (
        <AuthScreen testId="forgot-identifier-screen">
            <ScreenHeader title="Forgot password" />
            <AuthBody>
                <div className="pt-4 space-y-1 animate-fade-up">
                    <h2 className="font-display text-[22px] font-semibold tracking-tight">
                        Reset your password
                    </h2>
                    <p className="text-[13.5px] text-muted-foreground">
                        Enter the email or phone number linked to your account.
                    </p>
                </div>

                <div className="mt-8 animate-fade-up" style={{ animationDelay: "80ms" }}>
                    <TextField
                        testId="forgot-identifier-input"
                        label="Email or phone"
                        placeholder="you@mail.com or +234…"
                        value={value}
                        onChange={(v) => {
                            setValue(v);
                            if (error) setError(null);
                        }}
                        autoFocus
                        autoComplete="username"
                        error={error}
                        onKeyDown={(e) => e.key === "Enter" && handleContinue()}
                    />
                </div>
            </AuthBody>

            <AuthFooter>
                <PrimaryButton testId="forgot-identifier-continue" onClick={handleContinue}>
                    Send code
                </PrimaryButton>
            </AuthFooter>
        </AuthScreen>
    );
};

export default ForgotIdentifier;
